import { useMutation, useQueryClient } from 'react-query'
import { useSelector } from 'react-redux'

import { makeSelectContentTypesByModel } from '@webapp/core/stores/global'
import { permissionRepository } from '@webapp/platform/iam/data-access/repositories/PermissionRepository'
import { reportAccessGrantListQueryKeyPrefix } from '@webapp/platform/iam/query-configs/reportAccessGrant'

export const useMutateGrantReportAccessToAllPrimaryCategories = () => {
  const queryClient = useQueryClient()
  const secondaryCategoryContentType = useSelector(
    makeSelectContentTypesByModel('procurify', 'department')
  )

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({ userAuthId }: { userAuthId: number }) =>
      permissionRepository.grantReportAccessToAllPrimaryCategories({
        userAuthId,
        secondaryCategoryContentTypeId: secondaryCategoryContentType.id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(reportAccessGrantListQueryKeyPrefix)
    },
  })

  return {
    grantReportAccessToAllPrimaryCategories: mutateAsync,
    isGranting: isLoading,
  }
}
